<template>
  <div style="height: 100vh; height: calc(100vh - 71px); width: 100%; margin-bottom: -80px; min-height: 330px;">
    <l-map
      :zoom="zoom"
      :center="center"
      :options="mapOptions"
    >
      <l-tile-layer
        :url="url"
        :attribution="attribution"
      />
      <l-marker v-for="marker in markers" :key="marker.id" :lat-lng="marker.coords">
        <l-popup>
          <p>{{ marker.title }}</p>
        </l-popup>
      </l-marker>
    </l-map>
  </div>
</template>

<script>
import {
  latLng,
  Icon
} from 'leaflet'
import StationsAPI from '../api/station'
import 'leaflet/dist/leaflet.css'

import {
  LMap,
  LTileLayer,
  LMarker,
  LPopup
} from 'vue2-leaflet'

delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

export default {
  name: 'Map',
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup
  },
  data () {
    return {
      zoom: 6,
      center: latLng(48.443778, 33.013916),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      mapOptions: {
        zoomSnap: 0.5
      },
      stations: []
    }
  },
  computed: {
    markers () {
      return this.stations.filter(station => (station.lng !== null) && (station.lat !== null))
        .filter(station => (String(station.lng).length > 0) && (String(station.lat).length > 0))
        .map(station => {
          return {
            id: station.id,
            coords: latLng(parseFloat(station.lat), parseFloat(station.lng)),
            title: station.name
          }
        })
    }
  },
  methods: {
    centerUpdate (center) {
      this.currentCenter = center
    },
    showLongText () {
      this.showParagraph = !this.showParagraph
    }
  },
  mounted () {
    StationsAPI.findAll()
      .then(r => {
        this.stations = r.data
      })
  }
}
</script>
